<template>
    <div class="expression">
        <div class="banner">
            <div class="main">
                <div class="text-box">
                    <div class="m-title">AI表情及绑定</div>
                    <div class="s-title">一键自动化完成AI表情设置和骨骼蒙皮绑定</div>
                </div>
            </div>
        </div>
        <div class="scan">
            <div class="scan-item">
                <div class="main">
                    <div class="top">
                        <div class="common-title">
                            <div class="icon">
                                <img src="@/assets/imgs/common/title-icon.png" alt="">
                            </div>
                            <div class="text">表情动作</div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="item flex-static">
                            <div class="item-img">
                                <img src="@/assets/imgs/modeling/expression/img1.png" alt="表情系统" srcset="">
                            </div>
                            <div class="item-text ">
                                <img src="@/assets/imgs/modeling/expression/icon1.png" alt="" class="icon">
                                <div class="m-title">表情系统</div>
                                <div class="s-title">52个基础表情元素，</div>
                                <div class="s-title">可正确模拟喜怒哀乐思考等情绪能传达生动的微表情。</div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="item-text">
                                <img src="@/assets/imgs/modeling/expression/icon2.png" alt="" class="icon">
                                <div class="m-title">肢体动作</div>
                                <div class="s-title">常用20个基础动作，</div>
                                <div class="s-title">打招呼，敬礼，问候，再见等。并在问答等待过程中，用微动作进行过渡。</div>
                            </div>
                            <div class="item-img">
                                <img src="@/assets/imgs/modeling/expression/img2.png" alt="肢体动作" srcset="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="voice">
            <div class="main">
                <div class="common-title">
                    <div class="icon">
                        <img src="@/assets/imgs/common/title-icon.png" alt="">
                    </div>
                    <div class="text">语音识别</div>
                </div>
                <div class="voice-content">

                    <div class="item">
                        <div class="item-left">
                            <img src="@/assets/imgs/modeling/expression/img3.png" alt="文本转语音" srcset="">
                        </div>

                    </div>
                    <div class="item">
                        <div class="item-left">
                            <img src="@/assets/imgs/modeling/expression/img7.png" alt="文本转语音" srcset="">
                        </div>

                    </div>
                    <div class="item">
                        <div class="item-left">
                            <img src="@/assets/imgs/modeling/expression/img4.png" alt="语音识别" srcset="">
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="service">
            <div class="main">
                <div class="item-box">

                    <div class="item">
                        <img src="@/assets/imgs/modeling/expression/img5.png" alt="对话机器人" srcset="">
                        <div class="item-text">
                            <img src="@/assets/imgs/modeling/expression/icon3.png" alt="" class="icon">
                            <div class="s-title-box">
                                <div class="s-title">嵌入相对成熟的第三方对话机器人，</div>
                                <div class="s-title">介绍综合体相关的咨询信息</div>
                            </div>
                        </div>
                    </div>
                    <div class="item">
                        <img src="@/assets/imgs/modeling/expression/img6.png" alt="服务接口" srcset="">
                        <div class="item-text">
                            <img src="@/assets/imgs/modeling/expression/icon5.png" alt="" class="icon">
                            <div class="s-title-box">
                                <div class="s-title">预留任务服务接口，</div>
                                <div class="s-title">可与预约，咨询，推荐、活动等服务模块 扩展对接</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        goAnchor(selector) {//参数selector是id选择器（#anchor14）
            document.querySelector(selector).scrollIntoView({
                behavior: "smooth"
            });
        },
    }
}
</script>



<style lang="scss" scoped>
.expression {
    .banner {
        height: 615px;
        background: url('../../assets/imgs/modeling/expression/banner.png') no-repeat center center;
        background-size: cover;

        .main {

            position: relative;

            .text-box {
                position: absolute;
                left: 108px;
                top: 230px;

                .m-title {
                    font-size: 54px;
                    font-weight: 600;
                    letter-spacing: 6px;
                    color: #fff;
                    margin-bottom: 16px;
                }

                .s-title {
                    font-size: 28px;
                    font-weight: 400;
                    letter-spacing: 4px;
                    color: #fff;
                    margin-bottom: 6px;
                }

            }
        }
    }

    .scan {
        background: url('../../assets/imgs/modeling/expression/bg.png') no-repeat;
        height: 1454px;
        background-size: cover;

        .scan-item {
            padding: 0px 0 10px;

            .content {
                padding-top: 60px;

                .item {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 125px;

                    &.flex-static {
                        justify-content: flex-start;

                        .item-text {
                            margin-left: 180px;
                        }
                    }

                    &-img {
                        width: 784px;
                        height: 422px;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }

                    &-text {
                        margin-top: 70px;
                        width: 390px;

                        .icon {
                            width: 52px;
                            height: 52px;
                        }

                        .m-title {
                            font-size: 30px;
                            font-weight: 400;
                            color: #4D4948;
                            margin: 36px 0 10px;
                        }

                        .s-title {
                            font-size: 16px;
                            color: #4D4948;
                            line-height: 30px;
                        }
                    }
                }
            }


        }


    }


    .voice {
        padding: 0px 0 190px;
        background: #fff;

        .voice-content {
            display: flex;
            justify-content: space-between;
            .item {
                margin-top: 70px;
                width: 468px;
                height: 472px;
                .item-left {
                    width: 468px;
                    height: 472px;
                    img {
                        width: 468px;
                        height: 472px;
                        object-fit: cover;
                    }
                }

            }
        }
    }

    .service {
        background: #E2E5EE;
        height: 1100px;

        .item-box {
            display: flex;
            padding-top: 145px;

            .item {
                width: 720px;
                position: relative;

                img {
                    width: 720px;
                    height: 100%;
                    object-fit: cover;
                }

                &-text {
                    width: 360px;
                    position: absolute;
                    left: 149px;
                    top: 500px;
                    display: flex;

                    .icon {
                        width: 52px;
                        height: 52px;
                    }

                    .s-title-box {
                        margin-left: 40px;

                        .s-title {
                            font-size: 16px;
                            color: #4D4948;
                            line-height: 28px;
                        }
                    }
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/modeling/expression.vue